
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, X, Disc, Youtube } from 'lucide-react';

const mixes = [
  { 
    id: "mix1",
    name: "Luxury Wedding Party Mix", 
    platform: "YouTube / Live", 
    date: "Best Of 2024", 
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=800",
    embed: "https://www.mixcloud.com/djsaffmusic/afrobeats-vibes/" 
  },
  { 
    id: "mix2",
    name: "Generalist Open Format Set", 
    platform: "Mixcloud", 
    date: "Exclusive Mix", 
    image: "https://images.unsplash.com/photo-1571266028243-e4bb333941da?auto=format&fit=crop&q=80&w=800",
    embed: "https://player-widget.mixcloud.com/widget/iframe/?feed=%2Fdj_saff_afrobeats%2Fafrohouse-vibes%2F"


    //<iframe width="100%" height="400" src="https://player-widget.mixcloud.com/widget/iframe/?feed=%2Fdj_saff_afrobeats%2Fafrohouse-vibes%2F" frameborder="0" allow="encrypted-media; fullscreen; autoplay; idle-detection; speaker-selection; web-share;" ></iframe>
  },
  { 
    id: "mix3",
    name: "Signature Afro Vibes Session", 
    platform: "Mixcloud", 
    date: "Amapiano & Afrohouse", 
    image: "https://images.unsplash.com/photo-1563841930606-67e2b24c9106?auto=format&fit=crop&q=80&w=800",
    embed: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&light=0&feed=%2Fdj_saff_afrobeats%2Fafrobeats-special-edition%2F"
  },
];

const MusicSection: React.FC = () => {
  const [activeMix, setActiveMix] = useState<string | null>(null);

  return (
    <section id="music" className="py-24 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <motion.span 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-gold text-xs font-bold tracking-[0.4em] uppercase"
          >
            Maîtrise du Répertoire
          </motion.span>
          {/*<motion.h2 */}
          {/*  initial={{ opacity: 0, y: 20 }}*/}
          {/*  whileInView={{ opacity: 1, y: 0 }}*/}
          {/*  className="text-4xl md:text-6xl font-serif font-bold mt-4"*/}
          {/*>*/}
          {/*  Lecture <span className="text-gold-gradient italic">Intégrée</span>*/}
          {/*</motion.h2>*/}
        </div>

        {/*<div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">*/}
        {/*  {mixes.map((mix, idx) => (*/}
        {/*    <motion.div*/}
        {/*      key={mix.id}*/}
        {/*      initial={{ opacity: 0, y: 30 }}*/}
        {/*      whileInView={{ opacity: 1, y: 0 }}*/}
        {/*      viewport={{ once: true }}*/}
        {/*      transition={{ delay: idx * 0.15, duration: 0.8 }}*/}
        {/*      className="group relative block aspect-[4/5] rounded-[2.5rem] overflow-hidden glass border-white/5 bg-dark-lighter shadow-2xl"*/}
        {/*    >*/}
        {/*      <AnimatePresence mode="wait">*/}
        {/*        {activeMix !== mix.id ? (*/}
        {/*          <motion.div */}
        {/*            key="cover"*/}
        {/*            initial={{ opacity: 0 }}*/}
        {/*            animate={{ opacity: 1 }}*/}
        {/*            exit={{ opacity: 0 }}*/}
        {/*            className="absolute inset-0"*/}
        {/*          >*/}
        {/*            <img */}
        {/*              src={mix.image} */}
        {/*              alt={mix.name} */}
        {/*              className="w-full h-full object-cover grayscale opacity-40 group-hover:grayscale-0 group-hover:opacity-80 transition-all duration-1000"*/}
        {/*            />*/}
        {/*            <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/40 to-transparent" />*/}
                    
        {/*            <div className="absolute inset-0 flex items-center justify-center">*/}
        {/*              <button */}
        {/*                onClick={() => setActiveMix(mix.id)}*/}
        {/*                className="w-20 h-20 rounded-full bg-gold flex items-center justify-center text-dark shadow-[0_0_30px_rgba(212,175,55,0.5)] transform hover:scale-110 transition-all duration-300"*/}
        {/*              >*/}
        {/*                <Play size={32} fill="currentColor" className="ml-1" />*/}
        {/*              </button>*/}
        {/*            </div>*/}

        {/*            <div className="absolute bottom-0 left-0 right-0 p-8">*/}
        {/*              <div className="flex items-center justify-between mb-2">*/}
        {/*                <span className="text-gold text-[10px] font-bold tracking-widest uppercase bg-gold/10 px-3 py-1 rounded-full border border-gold/20">*/}
        {/*                  {mix.platform}*/}
        {/*                </span>*/}
        {/*              </div>*/}
        {/*              <h3 className="text-2xl font-serif font-bold leading-tight">*/}
        {/*                {mix.name}*/}
        {/*              </h3>*/}
        {/*            </div>*/}
        {/*          </motion.div>*/}
        {/*        ) : (*/}
        {/*          <motion.div */}
        {/*            key="player"*/}
        {/*            initial={{ opacity: 0, scale: 0.9 }}*/}
        {/*            animate={{ opacity: 1, scale: 1 }}*/}
        {/*            exit={{ opacity: 0, scale: 0.9 }}*/}
        {/*            className="absolute inset-0 bg-dark z-20 flex flex-col"*/}
        {/*          >*/}
        {/*            <div className="flex justify-between items-center p-4 border-b border-white/10 bg-dark-lighter">*/}
        {/*              <span className="text-[10px] font-bold uppercase tracking-widest text-gold">Lecteur Intégré</span>*/}
        {/*              <button */}
        {/*                onClick={() => setActiveMix(null)}*/}
        {/*                className="text-white/40 hover:text-white transition-colors"*/}
        {/*              >*/}
        {/*                <X size={20} />*/}
        {/*              </button>*/}
        {/*            </div>*/}
        {/*            <div className="flex-grow">*/}
        {/*              <iframe */}
        {/*                width="100%" */}
        {/*                height="100%" */}
        {/*                src={mix.embed} */}
        {/*                frameBorder="0"*/}
        {/*                className="bg-dark"*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*          </motion.div>*/}
        {/*        )}*/}
        {/*      </AnimatePresence>*/}
        {/*    </motion.div>*/}
        {/*  ))}*/}
        {/*</div>*/}

        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          <motion.a 
            href="https://www.mixcloud.com/djsaffmusic/" 
            target="_blank" 
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            className="flex items-center space-x-3 px-10 py-5 glass border-gold/10 hover:border-gold/30 hover:bg-white/5 rounded-full transition-all group"
          >
            <Disc size={20} className="text-gold group-hover:rotate-180 transition-transform duration-1000" />
            <span className="text-xs font-bold uppercase tracking-[0.2em]">Mixcloud</span>
          </motion.a>

          <motion.a 
            href="https://www.youtube.com/@djsaffmusic" 
            target="_blank" 
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            className="flex items-center space-x-3 px-10 py-5 glass border-gold/10 hover:border-gold/30 hover:bg-white/5 rounded-full transition-all group"
          >
            <Youtube size={20} className="text-gold group-hover:scale-110 transition-transform" />
            <span className="text-xs font-bold uppercase tracking-[0.2em]">Chaîne YouTube</span>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default MusicSection;
